<template>
  <fragment>
    <AppBody
      title="Vendas"
      :subtitle="$t('sales.list')"
      :actions="actions"
      :primaryLoading="loadingExportCSV"
      :secondaryLoading="loadingExportPDF"
    >
      <CardModule untitle>
        <ExpansionPanelFilters>
          <v-form @submit.prevent="filterVendas" class="search-forms">
            <v-row>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('sales.customer_name')"
                  :placeholder="$t('sales.customer_name_placeholder')"
                  v-model="$vendas.filter.nome_consumidor"
                  data-cy="nome-consumidor"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('sales.email')"
                  :placeholder="$t('sales.email_placeholder')"
                  v-model="$vendas.filter.email_consumidor"
                  data-cy="email-consumidor"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('sales.code')"
                  :placeholder="$t('sales.code_placeholder')"
                  v-model="$vendas.filter.cod_pedido"
                  data-cy="codigo-pedido"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :label="$t('sales.status')"
                  :placeholder="$t('sales.status_placeholder')"
                  :items="$vendas.status_pedido"
                  item-text="value"
                  item-value="key"
                  data-cy="status"
                  v-model="$vendas.filter.status"
                  clearable
                  @click:clear="clearFilterFields('status')"
                >
                </BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <BaseTextField
                      :label="$t('sales.start_date_placeholder')"
                      :placeholder="placeholderData"
                      v-model="dtInicial"
                      append-icon="mdi-calendar-blank-outline"
                      v-bind="attrs"
                      v-on="on"
                      data-cy="data-inicial"
                      clearable
                      @click:clear="clearFilterFields('data_inicio')"
                    ></BaseTextField>
                  </template>
                  <v-date-picker
                    v-model="$vendas.filter.data_inicial"
                    :active-picker.sync="activePicker"
                    min="1950-01-01"
                    @change="save"
                    locale="pt"
                    :header-color="$config.dados.corinputs"
                    landscape
                    :color="$config.dados.corinputs"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('sales.start_hour')"
                  :placeholder="placeholderHora"
                  v-model="$vendas.filter.hora_inicial"
                  data-cy="hora-inicial"
                  v-mask="'##:##'"
                  append-icon="mdi-clock-outline"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <BaseTextField
                      :label="$t('sales.finish_date_placeholder')"
                      v-model="dtFinal"
                      append-icon="mdi-calendar-blank-outline"
                      v-bind="attrs"
                      v-on="on"
                      data-cy="data-final"
                      :placeholder="placeholderData"
                      clearable
                      @click:clear="clearFilterFields('data_final')"
                    ></BaseTextField>
                  </template>
                  <v-date-picker
                    v-model="$vendas.filter.data_final"
                    :active-picker.sync="activePicker2"
                    min="1950-01-01"
                    @change="save2"
                    locale="pt"
                    :header-color="$config.dados.corinputs"
                    :color="$config.dados.corinputs"
                    landscape
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseTextField
                  :label="$t('sales.final_hour')"
                  :placeholder="placeholderHora"
                  v-model="$vendas.filter.hora_final"
                  data-cy="hora-final"
                  v-mask="'##:##'"
                  append-icon="mdi-clock-outline"
                >
                </BaseTextField>
              </v-col>
              <v-col cols="12" md="3" sm="4" v-if="isAdmin">
                <BaseSelect
                  :label="$t('sales.region')"
                  :placeholder="$t('sales.region_placeholder')"
                  :items="$loja_gerenciar.regionais"
                  item-text="nome"
                  item-value="idregional"
                  data-cy="regional"
                  v-model="$vendas.filter.regional"
                  clearable
                  @click:clear="clearFilterFields('regional')"
                ></BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :label="$t('sales.payment_method')"
                  :placeholder="$t('sales.payment_method_placeholder')"
                  :items="$relatorios_sinteticos.formas_de_pagamento"
                  item-text="key"
                  item-value="value"
                  data-cy="forma-pagamento"
                  v-model="$vendas.filter.forma_pagamento"
                  clearable
                  @click:clear="clearFilterFields('forma_de_pagamento')"
                ></BaseSelect>
              </v-col>
              <v-col cols="12" md="3" sm="4">
                <BaseSelect
                  :label="$t('sales.sales_channel')"
                  :placeholder="$t('sales.sales_channel_placeholder')"
                  :items="$relatorios_sinteticos.canais_de_venda"
                  item-text="value"
                  item-value="key"
                  data-cy="canal-vendas"
                  v-model="$vendas.filter.canal_de_vendas"
                  clearable
                  @click:clear="clearFilterFields('canal_de_venda')"
                ></BaseSelect>
              </v-col>
              <v-col class="d-flex justify-end">
                <BaseButton
                  variant="filter"
                  data-cy="filtrar"
                  type="submit"
                  :loading="$vendas.loading_button"
                >
                  {{ $t("common.filter") }}
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </ExpansionPanelFilters>

        <v-data-table
          class="table-body"
          :no-data-text="$t('sales.no_sales')"
          :loading-text="$t('sales.loading_information')"
          mobile-breakpoint="0"
          :headers="headers"
          :items="orderedVendas"
          :items-per-page="10"
          :loading="$vendas.loading_vendas"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 50],
            itemsPerPageText: $t('sales.sales_by_page'),
          }"
        >
          <template v-slot:item.data_pagamento="{ item }">
            {{ item.data_pagamento | dthr_pt_br }}
          </template>
          <template v-slot:item.valor="{ item }">
            {{ item.valor | moeda }}
          </template>
          <template v-slot:item.data_criacao="{ item }">
            {{ item.data_criacao | dthr_pt_br }}
          </template>
          <template v-slot:item.form_pag="{ item }">
            {{ item.forma_pag === "QRCODE" ? "PIX" : item.forma_pag }}
          </template>
          <template v-slot:item.actions="{ item }" class="table-actions">
            <div style="display: flex; justify-content: center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :color="$config.dados.corinputs"
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      item.idpedido_marketplace
                        ? openModalMkt(
                            item.idpedido_marketplace,
                            item.ano_mes,
                            item.idconsumidor,
                            item.permite_cancelamento_item
                          )
                        : openModal(
                            item.idpedido,
                            item.sequenciador,
                            item.idconsumidor,
                            item.permite_cancelamento_item
                          )
                    "
                    class="mr-2"
                  >
                    <v-icon>mdi-book-open-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("sales.details") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    height="30"
                    width="30"
                    small
                    icon
                    v-bind="attrs"
                    v-on="on"
                    :color="$config.dados.corinputs"
                    :disabled="
                      item.canal_venda === 'PDV_POS' || item.status !== 'Pago'
                    "
                    @click="cancelOrder(item)"
                  >
                    <v-icon>mdi-basket-remove-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("sales.cancel_order") }}</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <SalesDetailsDialog
          v-if="salesDetailsDialog"
          v-model="salesDetailsDialog"
          :idPedidoMarketplace="details.idpedido_marketplace"
          :idConsumidor="details.idconsumidor"
          :anoMes="details.ano_mes"
          :allowItemCancel="details.permite_cancelamento_item"
          @close="salesDetailsDialog = false"
        />
        <ModalCancelamento
          :dialog="cancelOrderDialog"
          :subtitle="$t('sales.cancel_order_subtitle')"
          :required="true"
          :title="$t('sales.confirm_title')"
          :okText="$t('sales.modal_ok')"
          :cancelText="$t('sales.modal_cancel')"
          :loading="$loja_gerenciar.cadastro.loading"
          @confirm-modal="confirmCancelOrder"
          @close-modal="closeModalCancellation"
        >
          <template v-slot:content>
            <v-checkbox
              v-if="isAdmin"
              v-model="cancelarTaxas"
              :label="$t('sales.cancel_taxes')"
            ></v-checkbox>
            <BaseTextarea
              required
              rows="3"
              v-model="motivoCancelamento"
              :label="$t('sales.cancel_justification')"
              :rules="[rules.required]"
            />
            <v-alert text type="info" class="mt-6 mb-2">
              {{ $t("sales.cancel_alert") }}
            </v-alert>
          </template>
        </ModalCancelamento>
      </CardModule>
    </AppBody>
  </fragment>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import { ENDPOINTS } from "@/services/Endpoints.js";
import mixins from "@/mixins";

import _ from "lodash";

const { formRules } = mixins;
export default {
  name: "Sales",
  mixins: [formRules],
  components: {
    BaseTextarea: () => import("@/components/forms/BaseTextarea.vue"),
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    CardModule: () => import("@/components/cards/CardModule.vue"),
    BaseTextField: () => import("@/components/forms/BaseTextField.vue"),
    BaseSelect: () => import("@/components/forms/BaseSelect.vue"),
    BaseButton: () => import("@/components/forms/BaseButton.vue"),
    SalesDetailsDialog: () =>
      import("@/components/vendas/SalesDetailsDialog.vue"),
    ModalCancelamento: () =>
      import("@/components/vendas/ModalCancelamento.vue"),
    ExpansionPanelFilters: () =>
      import("@/components/forms/ExpansionPanelFilters.vue"),
  },
  metaInfo: {
    title: "Vendas | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Vendas | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      activePicker: null,
      activePicker2: null,
      activePicker3: null,
      activePicker4: null,
      date: null,
      hour: null,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dtInicial: "",
      dtFinal: "",
      horaInicial: "",
      horaFinal: "",
      placeholderData: "dd/mm/aa",
      placeholderHora: "hh:mm",
      regional: [],
      form_pag: [],
      cnl_venda: [],
      agentes: [],
      pdvs: [],
      order_type: "",
      idpedido: "",
      idpedido_mktplace: "",
      motivoCancelamento: "",
      cancelarTaxas: false,
      details: {
        idconsumidor: "",
        ano_mes: 0,
        idpedido_marketplace: "",
        permite_cancelamento_item: false,
      },
      cancellation: {
        idconsumidor: "",
        idloja: "",
        loja: "",
        data_pagamento: "",
        motivo_cancelamento: "",
        cancelar_taxas: false,
      },
      mktplace_cancellation: {
        idconsumidor: "",
        idloja: "",
        lojas: "",
        ano_mes: "",
        data_pagamento: "",
        motivo_cancelamento: "",
        cancelar_taxas: false,
      },
      salesDetailsDialog: false,
      actions: [
        {
          id: "CSV",
          name: "",
          icon: "mdi-microsoft-excel",
          action: () => this.exportCSV(),
        },
        {
          id: "PDF",
          name: "",
          icon: "mdi-file-pdf-box",
          action: () => this.exportPDF(),
        },
      ],
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "MONTH"));
    },
    menu2(val) {
      val && setTimeout(() => (this.activePicker2 = "MONTH"));
    },
    menu3(val) {
      val && setTimeout(() => (this.activePicker3 = "HOUR"));
    },
    menu4(val) {
      val && setTimeout(() => (this.activePicker4 = "HOUR"));
    },
  },
  methods: {
    ...mapActions(["exportSales"]),
    ...mapMutations(["toggleCancelOrderDialog"]),
    filterVendas() {
      this.$vendas.filtroVendas();
    },
    save(date) {
      this.$refs.menu.save(date);
      this.dtInicial = this.$config.convertDataBR(date);
    },
    save2(date) {
      this.$refs.menu2.save(date);
      this.dtFinal = this.$config.convertDataBR(date);
    },
    save3(hour) {
      this.$refs.menu3.save(hour);
      this.horaInicial = hour;
    },
    save4(hour) {
      this.$refs.menu4.save(hour);
      this.horaFinal = hour;
    },
    clearFilterFields(field) {
      switch (field) {
        case "status":
          this.$vendas.filter.status = "";
          break;
        case "regional":
          this.$vendas.filter.regional = "";
          break;
        case "forma_de_pagamento":
          this.$vendas.filter.forma_pagamento = "";
          break;
        case "loja":
          this.$vendas.filter.loja = "";
          break;
        case "canal_de_venda":
          this.$vendas.filter.canal_venda = "";
          break;
        case "agente":
          this.$vendas.filter.agente = "";
          break;
        case "data_inicio":
          this.$vendas.filter.data_inicial = "";
          this.dtInicial = "";
          break;
        case "data_final":
          this.$vendas.filter.data_final = "";
          this.dtFinal = "";
          break;
        case "hora_inicial":
          this.$vendas.filter.hora_inicial = "";
          this.horaInicial = "";
          break;
        case "hora_final":
          this.$vendas.filter.hora_final = "";
          this.horaFinal = "";
          break;
        default:
          break;
      }
    },
    openModal(pedido, loja, idconsumidor, permite_cancelamento_item) {
      this.salesDetailsDialog = true;
      this.$vendas.idconsumidor = idconsumidor;
      this.details.permite_cancelamento_item = permite_cancelamento_item;
      this.$vendas.getItensPedido(pedido, loja);
    },
    openModalMkt(pedido, ano_mes, idconsumidor, permite_cancelamento_item) {
      this.salesDetailsDialog = true;
      this.$vendas.idconsumidor = idconsumidor;
      this.details.idpedido_marketplace = pedido;
      this.details.ano_mes = ano_mes;
      this.details.idconsumidor = idconsumidor;
      this.details.permite_cancelamento_item = permite_cancelamento_item;
      this.$vendas.getItensPedidoMkt(pedido, ano_mes);
    },
    closeModalCancellation() {
      this.toggleCancelOrderDialog();
      this.motivoCancelamento = "";
      this.cancelarTaxas = false;
    },
    confirmCancelOrder() {
      this.cancellation.motivo_cancelamento = this.motivoCancelamento;
      this.mktplace_cancellation.motivo_cancelamento = this.motivoCancelamento;
      this.cancellation.cancelar_taxas = this.cancelarTaxas;
      this.mktplace_cancellation.cancelar_taxas = this.cancelarTaxas;

      if (
        this.cancellation.motivo_cancelamento == "" ||
        this.mktplace_cancellation.motivo_cancelamento == ""
      ) {
        this.$config.alert(
          this.$t("sales.cancel_justification_alert"),
          this.$config.dados.errorColor
        );
        return;
      } else {
        if (this.order_type === "generic") {
          this.$axios.post(
            this.ENDPOINTS.CANCELAR_PEDIDO + this.idpedido,
            JSON.stringify(this.cancellation)
          );
          this.motivoCancelamento = "";
          this.cancelarTaxas = false;
          this.toggleCancelOrderDialog();
          return;
        }
        this.mktplace_cancellation.lojas = this.$vendas.lojas_mkt;

        this.$axios.post(
          this.ENDPOINTS.CANCELAR_PEDIDO_MKTPLACE + this.idpedido_mktplace,
          JSON.stringify(this.mktplace_cancellation)
        );

        this.motivoCancelamento = "";
        this.cancelarTaxas = false;
        this.toggleCancelOrderDialog();
      }
    },
    cancelOrder(order) {
      if (order.idpedido_marketplace !== "") {
        this.$vendas.getItensPedidoMkt(
          order.idpedido_marketplace,
          order.ano_mes
        );
        this.order_type = "marketplace";
        this.idpedido_mktplace = order.idpedido_marketplace;
        this.mktplace_cancellation.idconsumidor = order.idconsumidor;
        this.mktplace_cancellation.idloja = order.idloja;
        this.mktplace_cancellation.ano_mes = order.ano_mes;
        this.mktplace_cancellation.data_pagamento = order.data_pagamento;
        this.toggleCancelOrderDialog();
        return;
      }

      this.order_type = "generic";
      this.idpedido = order.idpedido;
      this.cancellation.idconsumidor = order.idconsumidor;
      this.cancellation.idloja = order.idloja;
      this.cancellation.loja = order.sequenciador;
      this.cancellation.data_pagamento = order.data_pagamento;
      this.toggleCancelOrderDialog();
    },
    exportCSV() {
      this.exportSales({ ...this.filters, exportation: "CSV" });
    },
    exportPDF() {
      this.exportSales({ ...this.filters, exportation: "PDF" });
    },
  },
  computed: {
    ...mapGetters([
      "storeSequencial",
      "isAdmin",
      "cancelOrderDialog",
      "loadingExportCSV",
      "loadingExportPDF",
    ]),
    orderedVendas() {
      return _.orderBy(this.$vendas.vendas, ["data_criacao"], ["desc", "asc"]);
    },
    headers() {
      return [
        {
          text: this.$t("sales.code"),
          align: "center",
          sortable: false,
          value: "pedido",
          width: 160,
        },
        {
          text: this.$t("sales.customer_name"),
          align: "center",
          sortable: true,
          value: "nome",
          width: 180,
        },
        {
          text: this.$t("sales.email"),
          align: "center",
          sortable: false,
          value: "email",
          width: 60,
        },
        {
          text: this.$t("sales.store"),
          align: "center",
          sortable: true,
          value: "loja",
          width: 120,
        },
        {
          text: this.$t("sales.sales_channel"),
          align: "center",
          sortable: false,
          value: "canal_venda",
          width: 140,
        },
        {
          text: this.$t("sales.payment_method"),
          align: "center",
          sortable: true,
          value: "form_pag",
          width: 200,
        },
        {
          text: this.$t("sales.installments"),
          align: "center",
          sortable: true,
          value: "parcelas",
          width: 100,
        },
        {
          text: this.$t("sales.status"),
          align: "center",
          sortable: true,
          value: "status",
          width: 90,
        },
        {
          text: this.$t("sales.payment_date"),
          align: "center",
          sortable: false,
          value: "data_pagamento",
          width: 140,
        },
        {
          text: this.$t("sales.value"),
          align: "center",
          sortable: true,
          value: "valor",
          width: 80,
        },
        {
          text: this.$t("sales.createdDate"),
          align: "center",
          sortable: true,
          value: "data_criacao",
          width: 160,
        },
        {
          text: "Itens",
          align: "center",
          sortable: true,
          value: "qtd_itens_pedido",
          width: 70,
        },
        {
          text: this.$t("sales.actions"),
          align: "center",
          sortable: false,
          fixed: true,
          value: "actions",
        },
      ];
    },
    filters() {
      const filter = {
        idregional: this.$vendas.filter.regional,
        nome_consumidor: this.$vendas.filter.nome_consumidor,
        email_consumidor: this.$vendas.filter.email_consumidor,
        localizador: this.$vendas.filter.cod_pedido,
        ped_status: this.$vendas.filter.status,
        forma_pag: this.$vendas.filter.forma_pagamento,
        canal_venda: this.$vendas.filter.canal_de_vendas,
        ponto_de_venda: this.$vendas.filter.ponto_de_venda,
      };

      if (this.$vendas.filter.data_inicial) {
        Object.assign(filter, {
          dthr_ini_ped: `${this.$vendas.filter.data_inicial} ${
            this.$vendas.filter.hora_inicial || "00:00"
          }`,
        });
      }
      if (this.$vendas.filter.data_final) {
        Object.assign(filter, {
          dthr_fim_ped: `${this.$vendas.filter.data_final} ${
            this.$vendas.filter.hora_final || " 23:59"
          }`,
        });
      }

      return filter;
    },
  },
  mounted() {
    if (this.$loja_gerenciar.lojas.length == 0 && this.isAdmin) {
      this.$loja_gerenciar.getAllLojas();
    }
    this.$loja_gerenciar.getRegionais();
    this.$relatorios_sinteticos.getCanaisDeVenda();
    this.$relatorios_sinteticos.getFormasDePagamento();
    this.$vendas.getStatusPedido();
    this.$vendas.getVendas({ sequencial: this.storeSequencial });
  },
  destroyed() {
    this.$vendas.limpaFiltros();
  },
};
</script>

<style scoped></style>
